import React from 'react';
import type { OrderWidgetProps } from './types';
import { DeityDaily } from '../DeityDaily';
import type { DmtToolId } from '../spectrum-tools';

/** MoyRi ORDER-band widget: the daily deity check-in — five ORDER placards
 *  (icon · points · a circle per active principle, green when done today),
 *  replacing the old single-habit spectrum swap. */
export function MoyriWidget({ userId, onOpenTool, onOpen, onEngage }: OrderWidgetProps) {
  return (
    <DeityDaily
      userId={userId}
      onOpenTool={(toolId: DmtToolId) => (onOpenTool ? onOpenTool(toolId) : onOpen())}
      onEngage={onEngage}
    />
  );
}
